module.exports = __webpack_public_path__ + "static/img/food-policy014.d0be21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy014.png
// module id = SIH0
// module chunks = 1